module.exports = __webpack_public_path__ + "public/images/tg_icon.e18078625a983f92062d84750d88e8da.webp";